import * as z from "zod";
import type { Ctx } from "../../types";
import { FormAction } from "gg-wf-scripts";
import { parse } from "../_helpers";

const sign_in_schema = z.object({
  email: z.email("Please enter a valid email"),
  password: z
    .string({ error: "Password is required" })
    .min(1, "Password is required"),
});

export const sign_in: FormAction<Ctx> = async ({ sb }, formData, _params) => {
  const parsed = parse(sign_in_schema, formData);
  if (!parsed.ok) return parsed;

  const { email, password } = parsed.data;
  const { error } = await sb.auth.signInWithPassword({ email, password });
  if (error) return { ok: false, error: error.message };

  const {
    data: { session },
  } = await sb.auth.getSession();
  const role = session?.user?.app_metadata?.role;
  switch (role) {
    case "superuser":
      window.location.href = "/app/admin/dashboard";
      break;
    case "school_admin":
      window.location.href = "/app/school/dashboard";
      break;
    case "substitute":
      window.location.href = "/app/open-jobs";
      break;
    default:
      window.location.href = "/";
  }
  return { ok: true };
};
